<template>
  <v-footer v-if="showFooter" id="core-footer">
    <div class="footer-items">
      <span v-for="link in links" :key="link.name">
        <a
          target="_blank"
          :href="link.Link"
          class="tertiary--text footer-links"
          >{{ link.name }}</a
        >
      </span>
    </div>
    <span class="copyright">
      &copy;
      {{ new Date().getFullYear() }}
      <a href="https://enercred.com.br/" target="_blank"
        ><img
          width="80px"
          height="auto"
          class="img"
          src="/../img/newJuntos_logo_color.png"
          alt="Juntos Energia"
      /></a>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    showFooter: false,
    links: [
      { name: "Juntos Energia", Link: "https://juntosenergia.com.br/" },
      { name: "Sobre Nós", Link: "https://juntosenergia.com.br/quem-somos/" },
      { name: "Blog", Link: "https://juntosenergia.com.br/blog" },
    ],
  }),
  watch: {
    $route(val) {
      if (val.meta.fullpage) {
        this.showFooter = false;
      } else {
        this.showFooter = true;
      }
    },
  },
};
</script>

<style>
#core-footer {
  z-index: 0;
  background: #f6f6f6;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100% !important;
  height: fit-content !important;
  padding: 16px 34px 16px 19px;
  margin-top: auto !important;
}
.copyright {
  font-weight: 400 !important;
}
.img {
  transform: translateY(4px);
}
</style>
